import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Qué recibiré al comprar?',
  a: 'Recibirás una guía digital en formato PDF con una rutina práctica de autocuidado, revisión, higiene y confort para aplicar desde casa.'
}, {
  q: '¿Es un producto físico?',
  a: 'No. Es un producto 100% digital. No se enviará ningún artículo físico.'
}, {
  q: '¿Cómo recibo mi compra?',
  a: 'Después de completar el pago, recibirás acceso para descargar tu archivo digital.'
}, {
  q: '¿Puedo verlo desde mi celular?',
  a: 'Sí. Puedes abrirlo desde celular, tablet o computadora.'
}, {
  q: '¿Está en español?',
  a: 'Sí. Toda la guía está escrita en español.'
}, {
  q: '¿Es fácil de leer?',
  a: 'Sí. Fue diseñada con una estructura clara, visual y fácil de seguir.'
}, {
  q: '¿Esta guía sustituye ayuda profesional?',
  a: 'No. Es un recurso educativo de autocuidado general y no sustituye orientación profesional ni atención personalizada.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream-dark/20" data-id="element-92">
      <div className="max-w-3xl mx-auto px-6" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-94">
          <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-95">
            Preguntas frecuentes
          </h2>
          <div className="w-16 h-[1px] bg-bronze mx-auto" data-id="element-96" />
        </motion.div>

        <div className="space-y-4" data-id="element-97">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-bronze/20 bg-white" data-id="element-98">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-99">
                <span className="font-serif text-lg text-charcoal pr-8" data-id="element-100">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-101">
                  <ChevronDown className="w-5 h-5 text-bronze shrink-0" data-id="element-102" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-103">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-104">
                    <div className="p-6 pt-0 text-charcoal-light leading-relaxed" data-id="element-105">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}